import request from '..//index.js'
//1.获取联系方式
export const getlinkman = params => {
    return request({
        method: 'GET',
        url: '/api/nsc/front/ndContactConf/getContactConf',
        params
    })
}
//2.根据ID查询导航页面详情/api/nsc/front/ndFrontPage/getInfoById/{menuId}
export const getlag = menuid => {
    return request({
        method: 'GET',
        url: `/api/nsc/front/ndFrontPage/getInfoById/${menuid}`
    })
}
//获取的详情页接口
export const getpages= menuid => {
    return request({
        method: 'GET',
        url: menuid
})}
//获取轮播图接口 
export const getimgs= menuid => {
    return request({
        method: 'GET',
        url:`/api/nsc/front/ndFrontMenuBanner/getInfoById/${menuid}`
})}
//获取table栏接口
export const gettables= menuid => {
    return request({
        method: 'GET',
        url:`/api/nsc/front/ndFrontMenuTab/getInfoById/${menuid}`
})}